<template>
    <div class="price-tooltip table">
        <button class="price-tooltip-close" @click="closeTolltip()">
            <svg class="close"><use xlink:href="#close"></use></svg>
        </button>

        <p class="info">Verified spots have our team’s stamp of approval.</p>
    </div>
</template>
<script>
export default {

    mounted() {
        $(document).on('click', '#verified-wt  .filter-info-popup-trigger', function () {
            $(this).toggleClass('active')
        })
    },

    methods: {
        closeTolltip() {
            $('#verified-wt  .filter-info-popup-trigger').removeClass('active')
        }
    }
}
</script>
